import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter } from "rxjs/operators";
// import FrameTypes from 'frame/actions/types'
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";
// import AuthorisationTypes from 'features/authorisation/actions/types'
import { onListReceived, onListFailed } from "../actions";
import fromTypes from "../actions/types";
import * as fromOrganisations from "features/organisations";

const siteListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			fromTypes.SITES_LIST_REQUESTED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => tokenExists()),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(() =>
			ajax
				.post(
					`${getOrganisationBaseUrl(state$.value)}/site/paged`,
					{
						page: 1,
						pageSize: 5000,
						orderBy: "status,siteName",
						ascending: true,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListReceived(ajaxResponse.response))
					),
					catchError((error) => of(onListFailed(error)))
				)
		)
	);

export const sitePagedListEffect = (action$, state$) =>
	action$.pipe(
		ofType(fromTypes.SITES_PAGED_LIST_REQUESTED),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => tokenExists()),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(({ payload }) => {
			const pagingParams = payload;
			return ajax
				.post(
					`${getOrganisationBaseUrl(state$.value)}/site/paged`,
					pagingParams,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(onListReceived(ajaxResponse.response))
					),
					catchError((error) => of(onListFailed(error)))
				);
		})
	);

export default siteListEffect;
